var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uik-cta"},[(!_vm.split)?_c('div',{staticClass:"uik-cta__row"},[_vm._t("default")],2):_vm._e(),(_vm.split)?_c('div',{staticClass:"uik-cta__column"},[_c('div',{staticClass:"uik-cta__column-top"},[_vm._t("top")],2),_c('div',{staticClass:"uik-cta__column-bottom"},[_vm._t("bottom")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }